import React, { Component } from "react";
import GapAnalyse from "../../../SurveyResults/GapAnalysis";
import SkillChart from "../../../../components/Charts/SkillChart";
import PieChart from "../../../../components/Charts/PieChart/PieChartSimple";
import { getData } from "../../../../components/Charts/chartData";
import BarChart from "../../../../components/Charts/BarChartContainer";
import PieCharts from "../../../../components/Charts/PieChart/PieCharts";
import ResultChart from "../../ResultChart";

export function PrintCharts(props) {
  switch (props.type) {
    case "profile":
      {
        return (
          <div
            style={{
              position: "absolute",
              width: 1000,
              height: 900,
              left: -10000
            }}
          >
            <div id="printPie">
              <PieCharts data={props.data.results} language={props.language} />
            </div>

            {Object.keys(props.drivers).length ? (
              <div id="printDrivers">
                <BarChart
                  drivers={props.drivers}
                  transactionalanalysisId={props.data.id}
                />
              </div>
            ) : (
              <div />
            )}
          </div>
        );
      }
    default: {
      return (
        <div>
          <div
            style={{
              position: "absolute",
              width: 2000,
              height: 900,
              left: 0,
              top: -10000
            }}
          >
            <div id={"printResultChart"}>
              <ResultChart
                data={props.mappedData}
                highlight={props.highlight}
                peer1Name={props.peer1Name}
                peer2Name={props.peer2Name}
                peer3Name={props.peer3Name}
                ownName={props.language === "en" ? "Own" : "Egen"}
                stroke_Color={"#000"}
                tick_Color={"#000"}
                language={props.language}
              />
            </div>

            <div id={"idskillchartPrint"}>
              <SkillChart
                id="skillchartPDF"
                data={props.data.results}
                peer1Name={props.peer1Name}
                peer2Name={props.peer2Name}
                peer3Name={props.peer3Name}
                highlight={"all"}
                stroke_Color={"#000"}
                tick_Color={"#000"}
                language={props.language}
              />
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              width: 1300,
              height: 880,
              left: 0,
              top: -10000
            }}
          >
            <div id="printGap">
              <GapAnalyse
                result={props.data.results
                  .sort((a, b) => b.difference - a.difference)
                  .filter((item, index) => index < 4)}
                groupedByCategory={props.data.groupedByCategory}
                language={props.language}
              />
            </div>
          </div>
        </div>
      );
    }
  }
}

export class IconCharts extends Component {
  render() {
    

    switch (this.props.type) {
      case "profile":
        return <PieChart data={this.props.item} />;
      default:
        return (
          <SkillChart
            chartHeight="150px"
            data={getData(this.props.item)}
            domain={[]}
            disableLegend
            disableAxisLine
            disableTick
          />
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultCollection/ResultsList/renderCharts.js